import React from 'react'

import { BASE_URL, ICONS } from '../../constants'

import { useOverlay } from '../hooks'

import styles from './OverlayListItem.module.css'

const OverlayListItem = ({ id }) => {
  const [overlay, toggle] = useOverlay(id)

  return (
    <li
      className={
        overlay.selected ? `${styles.item} ${styles.selected}` : styles.item
      }
      onClick={toggle}
    >
      <img
        className={styles.icon}
        alt={overlay.name}
        src={BASE_URL + ICONS.AI.BORDERLESS.DIR + overlay.icon}
      />
      <div className={styles.title}>{overlay.name}</div>
    </li>
  )
}

export default OverlayListItem
